import React from "react";


export default function PrivacyPolicyWel() {
    return (
        <div className="max-w-6xl mx-auto px-4 py-10 text-white">
            <h1 className="text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
            {/* <p className="text-center mb-4 text-sm text-gray-500">
                Last Updated: April 5, 2025
            </p> */}

            <p className="mb-6">
                This Privacy Policy ("Privacy Policy" or "Policy") describes how we collect, use, process, and disclose your personal data when you use the Wel SFA and Wel DMS applications.
            </p>

            <h2 className="text-2xl font-semibold mb-4">User-Provided Information</h2>
            <p className="mb-6">
                To use the Wel SFA and Wel DMS applications, users are required to provide certain information such as their mobile number, email address, and other relevant details during the registration process and while using the application.
            </p>
            <p className="mb-6">
                For further registration on CRM, we may collect additional personal information, including but not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Name</li>
                <li>Mobile Number</li>
                <li>Email ID</li>
                <li>Date of Birth</li>
                <li>Permanent Account Number (PAN)</li>
            </ul>

            <p className="mb-6">
                We assure you that we do not share any personal data collected from users with any third-party websites or external entities.
            </p>

            <h2 className="text-2xl font-semibold mb-4">Location Data</h2>
            <p className="mb-6">The Wel SFA and Wel DMS applications may collect and process location data from your device. This may include:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Approximate location (network-based)</li>
                <li>Precise location (GPS-based), if the user grants permission</li>
            </ul>


            <h2 className="text-2xl font-semibold mb-4">Why We Collect Location Data</h2>
            <p className="mb-6">Location data is used solely for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>To verify attendance, visits, or field activity</li>
                <li>To provide location-based features within the application</li>
                <li>To enhance service accuracy and improve user experience</li>
            </ul>

            <h2 className="text-2xl font-semibold mb-4">How Location Data Is Used</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Location data is processed within the application to support operational and workflow features.</li>
                <li>We do not use location data for advertising or sharing with third parties.</li>
                <li>Location access occurs only when required and only after the user grants permission.</li>
            </ul>

            <h2 className="text-2xl font-semibold mb-4">Data Sharing</h2>
            <p className="mb-6">We do not sell, share, or transfer any location data to external third parties.</p>

            <h2 className="text-2xl font-semibold mb-4">User Control</h2>
            <p className="mb-6">Users may choose to enable or disable location permissions at any time through their device settings. However, certain app functions may not work properly without location access.</p>

        </div>
    );
}
